import { Component, Input } from '@angular/core';

@Component({
  selector: 'action-realtor',
  templateUrl: './realtor.component.html',
  styleUrls: ['./realtor.component.scss']
})
export class RealtorComponent {

  @Input() action: any;

  constructor() { }


}
